// This function takes an object and recursively maps all empty string values to null.
// It was implemented to "bypass" the validator on backend. Function responsible for adding users always expects an email/personalEmail field, even if it's null.
// If an empty string is sent, the backend validator will throw an error.
export const mapEmptyStringsToNull = <T>(obj: T): T => {
  if (Array.isArray(obj)) {
    return <T>obj.map(mapEmptyStringsToNull);
  }
  if (obj && typeof obj === 'object') {
    return <T>(
      Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [
          key,
          value === '' ? null : mapEmptyStringsToNull(value),
        ]),
      )
    );
  }
  return obj;
};
